export const barMenuDataEn = {
  husetsVin: [
    {
      name: "House Wine White",
      description: "Fresh and fruity white wine",
      priceGlas: "75",
      priceFlaska: "395"
    },
    {
      name: "House Wine Red",
      description: "Soft and balanced red wine",
      priceGlas: "75",
      priceFlaska: "395"
    },
    {
      name: "House Wine Rosé",
      description: "Fresh and fruity rosé wine",
      priceGlas: "75",
      priceFlaska: "395"
    }
  ],
  vittVin: [
    {
      name: "Chardonnay",
      description: "Full-bodied with notes of tropical fruits and vanilla",
      priceGlas: "95",
      priceFlaska: "495",
      country: "France"
    },
    {
      name: "Sauvignon Blanc",
      description: "Fresh and crisp with notes of gooseberry and citrus",
      priceGlas: "89",
      priceFlaska: "465",
      country: "New Zealand"
    },
    {
      name: "Pinot Grigio",
      description: "Light and refreshing with notes of pear and apple",
      priceGlas: "85",
      priceFlaska: "445",
      country: "Italy"
    },
    {
      name: "Riesling",
      description: "Semi-sweet with notes of peach and honey",
      priceGlas: "92",
      priceFlaska: "485",
      country: "Germany"
    }
  ],
  rottVin: [
    {
      name: "Cabernet Sauvignon",
      description: "Full-bodied with notes of black currant and oak",
      priceGlas: "95",
      priceFlaska: "495",
      country: "Chile"
    },
    {
      name: "Merlot",
      description: "Soft and round with notes of plum and chocolate",
      priceGlas: "89",
      priceFlaska: "465",
      country: "France"
    },
    {
      name: "Shiraz",
      description: "Spicy and powerful with notes of blackberry and pepper",
      priceGlas: "92",
      priceFlaska: "485",
      country: "Australia"
    },
    {
      name: "Pinot Noir",
      description: "Elegant with notes of cherry and earth",
      priceGlas: "98",
      priceFlaska: "515",
      country: "France"
    }
  ],
  roseVin: [
    {
      name: "Provence Rosé",
      description: "Fresh and dry with notes of strawberry and citrus",
      priceGlas: "89",
      priceFlaska: "465",
      country: "France"
    },
    {
      name: "White Zinfandel",
      description: "Semi-sweet with notes of raspberry and melon",
      priceGlas: "79",
      priceFlaska: "425",
      country: "USA"
    }
  ],
  prosecco: [
    {
      name: "Prosecco Extra Dry",
      description: "Fresh and fruity sparkling wine",
      priceGlas: "85",
      priceFlaska: "445",
      country: "Italy"
    },
    {
      name: "Prosecco Rosé",
      description: "Fresh rosé sparkling wine with notes of strawberry",
      priceGlas: "89",
      priceFlaska: "465",
      country: "Italy"
    }
  ],
  cocktails: [
    {
      name: "Mojito",
      description: "White rum, fresh mint, lime, sugar and soda water",
      price: "125"
    },
    {
      name: "Margarita",
      description: "Tequila, triple sec, lime juice and salt",
      price: "125"
    },
    {
      name: "Cosmopolitan",
      description: "Vodka, cointreau, cranberry juice and lime",
      price: "125"
    },
    {
      name: "Old Fashioned",
      description: "Bourbon, sugar, bitters and orange",
      price: "135"
    },
    {
      name: "Espresso Martini",
      description: "Vodka, coffee liqueur and espresso",
      price: "135"
    },
    {
      name: "Aperol Spritz",
      description: "Aperol, prosecco and soda water",
      price: "115"
    },
    {
      name: "Piña Colada",
      description: "White rum, coconut cream and pineapple juice",
      price: "125"
    },
    {
      name: "Singapore Sling",
      description: "Gin, cherry liqueur, pineapple juice and lime",
      price: "135"
    }
  ],
  ol: [
    {
      name: "Carlsberg",
      description: "Classic Swedish lager",
      price: "65",
      type: "Draft",
      size: "40 cl"
    },
    {
      name: "Falcon",
      description: "Swedish lager",
      price: "59",
      type: "Bottle",
      size: "33 cl"
    },
    {
      name: "Corona Extra",
      description: "Mexican lager",
      price: "69",
      type: "Bottle",
      size: "33 cl"
    },
    {
      name: "Guinness",
      description: "Irish stout",
      price: "75",
      type: "Bottle",
      size: "33 cl"
    },
    {
      name: "Brooklyn Lager",
      description: "American amber lager",
      price: "72",
      type: "Bottle",
      size: "33 cl"
    },
    {
      name: "Alcohol-free",
      description: "Various alcohol-free beers",
      price: "49",
      type: "Bottle",
      size: "33 cl"
    }
  ],
  sprit: [
    {
      name: "Vodka",
      description: "Absolut, Smirnoff, Grey Goose",
      price: "75",
      unit: "4 cl"
    },
    {
      name: "Gin",
      description: "Bombay Sapphire, Tanqueray, Hendrick's",
      price: "85",
      unit: "4 cl"
    },
    {
      name: "Whiskey",
      description: "Jameson, Jack Daniel's, Johnnie Walker",
      price: "95",
      unit: "4 cl"
    },
    {
      name: "Rum",
      description: "Bacardi, Captain Morgan, Havana Club",
      price: "75",
      unit: "4 cl"
    },
    {
      name: "Tequila",
      description: "Jose Cuervo, Olmeca, Patrón",
      price: "85",
      unit: "4 cl"
    },
    {
      name: "Cognac",
      description: "Hennessy, Rémy Martin, Martell",
      price: "125",
      unit: "4 cl"
    },
    {
      name: "Liqueur",
      description: "Baileys, Amaretto, Cointreau",
      price: "65",
      unit: "4 cl"
    }
  ]
};
